import photo from './assets/me.jpg'
import './App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function App() {
  return (
    <div>

    <div className='flex font-sans bg-white h-screen'>
   
   {/* remove my-auto later */}
    <div className="my-auto container mx-auto md:w-3/5 ">
      
      <div className='flex items-center flex-col'>

      <div className='flex justify-center items-center'>
        <div className='transform transition delay-500 border border-4 border-dashed hover:border-solid border-indigo-500 rounded-full'>
          <img src={photo} className='rounded-full w-40 align-middle'></img>
        </div>

        <div className='sm:ml-5 ml-3 py-12 '>
          <div className='flex-col'>
            <div>
              <h1 className='text-4xl text-indigo-500'>Hello 👋 I am <span className='font-bold'>Taufiq</span></h1>
            </div>
            <div>
              <p className='font-bold text-gray-800'>(Muhammad Taufiq Hidayat)</p>
            </div>
            <div>
              <p className='text-sm text-gray-800'>Software Backend Engineer | Engineering Manager</p>
            </div>
            <div>
              <p className='text-md'>Let's Connect<span className='ml-2 text-indigo-500'>></span> 
              <a href='https://github.com/mtfiqh' target='_blank'><i className='hover:text-indigo-500 ml-2 fa fa-github'></i></a>
              <a href='https://linkedin.com/in/mtfiqh' target='_blank'><i className='hover:text-indigo-500 ml-2 fa fa-linkedin'></i></a>
              <a href='https://instagram.com/mtfiqh.dev' target='_blank'><i className='hover:text-indigo-500 ml-2 fa fa-instagram'></i></a>
              <a href='mailto:mtfiqh@gmail.com' target='_blank'><i className='hover:text-indigo-500 ml-2 fa fa-envelope'></i></a>
              </p>
            </div>
          </div>
        </div>

      </div>

      <div className='flex mb-3 max-w-lg text-center'>
        <p className='text-indigo-500 font-medium text-sm'>Backend Engineer who loves to learn and try new things, able to work independently or collaborate with teams as well. I am a learner by doing.</p>
      </div>

      </div>
    </div>
    </div>

    </div>
  );
}

export default App;
